/**
 * ConsultPage Component
 * Redesigned consultant-focused page with execution infrastructure messaging
 * Target: Consultants working on execution, alignment, and transformation
 */

import React, { useEffect } from 'react';
import { SEO } from '../../components/landing/SEO';
import { LandingNav, Footer } from '../../components/landing';
import { ClientHero } from '../../components/landing/ClientHero';
import { ClientHiddenCost } from '../../components/landing/ClientHiddenCost';
import { ClientReframe } from '../../components/landing/ClientReframe';
import { ClientHowConsultantsUse } from '../../components/landing/ClientHowConsultantsUse';
import { ClientWhatOKRHubProvides } from '../../components/landing/ClientWhatOKRHubProvides';
import { ClientWhoThisIsFor } from '../../components/landing/ClientWhoThisIsFor';
import { ClientHowConversationsStart } from '../../components/landing/ClientHowConversationsStart';
import { ClientExecutionFitForm } from '../../components/landing/ClientExecutionFitForm';

export const ConsultPage: React.FC = () => {
  useEffect(() => {
    // Scroll to top on mount
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* SEO Meta Tags */}
      <SEO
        title="Execution Infrastructure for Consultants | OKR Hub by HR4India"
        description="OKR Hub provides execution infrastructure for consultants working on leadership alignment, strategy execution, and organizational transformation. Prevent execution decay after engagements end."
        keywords="execution infrastructure, consultant tools, OKR consulting, execution governance, leadership alignment, strategy execution, organizational transformation, consultant execution platform"
        ogUrl="https://hr4india.com/consult"
      />

      {/* Navigation */}
      <LandingNav />

      {/* Main Content */}
      <main>
        {/* Section 1: Hero */}
        <ClientHero />

        {/* Section 2: The Hidden Cost to Consultants */}
        <ClientHiddenCost />

        {/* Section 3: The Reframe */}
        <ClientReframe />

        {/* Section 4: How Consultants Use OKR Hub */}
        <ClientHowConsultantsUse />

        {/* Section 5: What OKR Hub Provides */}
        <ClientWhatOKRHubProvides />

        {/* Section 6: Who This Is For */}
        <ClientWhoThisIsFor />

        {/* Section 7: How Conversations Start */}
        <ClientHowConversationsStart />

        {/* Execution Fit Form */}
        <ClientExecutionFitForm />
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};
